/**
 * Function to generate foldable javascript menu
 * @class JSMenu
 * @memberof EBContext.modules
 */
EBContext.modules.JSMenu = function() {
    let self = this;
    this.options = {
        data: {
            categories: EBContext.data.menuCategories.structure || {},
            seoidMap: null,
            firstSorting: EBContext.data.menuCategories.firstSorting || '',
            parentSEOID: EBContext.data.menuCategories.parentSEOID || '',
            propMap: {
                Children: 'Children',
                SEOID: 'SEOID',
                OID: 'OID',
                Name: 'Name',
                title: 'Name',
                Tooltip: 'Tooltip',
                iconImg: 'IconImg'
            },
            fnSortCategories: function(catsObj) {
                if (!Array.isArray(catsObj)) catsObj = Object.values(catsObj);
                catsObj.sort((a,b)=>{	// Z�znamy bez Order d�t nakonec
                	if(a.Order === null && b.Order !== null) return 1;
                	if(a.Order !== null && b.Order === null) return -1;
                	return 0;
                });
                catsObj.sort((a,b)=>{	// Z�znamy s Order se�adit dle Order
                	if(a.Order !== null && b.Order !== null) return a.Order - b.Order;
                	return 0;
                });
                catsObj.sort((a,b)=>{ // Sekund�rn� z�znamy se�adit dle Sortingu
                	if(a.Order === b.Order) return parseInt(a.Sorting.replace(/-/g, '')) - parseInt(b.Sorting.replace(/-/g, ''));
                	return 0;
            	});
                return catsObj;
            }
        },
        render: {
            menuWrapId: null,
            closeInactive: false,
            closeOnOutsideClick: false,
            menuLevelLimit: 10,
            templates: {
                itemHrefTemplate: EBContext.data.hrefMap.result_categoryseoid || '/categories/<!--$SEOID-->',
                menuItem: '<li class="jsmenu-item<!--$category.bgColor@setBgColor-->"><a class="jsmenu-link text-reset"<!--$Target?#target--><!--$Tooltip?#tooltip-->><!--#itemContent--></a></li>',
                itemContent: '<!--$renderChildren?#toggleEl:#dummyEl--><!--$iconImg?#iconImage--><!--#titleEl-->',
                childrenWrap: '',
                toggleEl: '<button class="jsmenu-toggle" title="<!--$open?~resource.SBALIT:~resource.ROZBALIT-->"><!--$open?#iconOpen:#iconClosed--></button>',
                iconOpen: '<i class="fas fa-fw fa-chevron-down"></i>',
                iconClosed: '<i class="fas fa-fw fa-chevron-right"></i>',
                iconImage: '<img src="<!--$iconImg-->" alt="<!--$title-->" class="menuIcon" />',
                dummyEl: '<div class="jsmenu-dummy"></div>',
                titleEl: '<span><!--@getIcon--><!--$title--></span>',
				target: ' target="<!--$Target-->"',
				tooltip: ' title="<!--$Tooltip-->"'
            },
            templateVariables: {
                getIcon: item=>{
                	if(item.category && item.category.Icon){
						let iconId = item.category.Icon;
						let iconStyle = iconId.match(/(^|\s)(fa\w)(\s|$)/g);
						iconStyle = (!iconStyle ? 'fas' : iconStyle[0].trim());
						iconId = iconId.replace(/(^|\s)(fa\w)(\s|$)/g, '').trim();
						iconId = (iconId.indexOf('fa-') === 0 ? '' : 'fa-') + iconId;
						return '<i class="' + iconStyle + ' fa-fw me-2 ' + iconId + '" ></i>';
					}
					return '';
                },
                setBgColor: (color)=>(color ? ' bg-' + color : ' text-reset')
            },
            fnToggleCategory: function(catEl, open) {
                let toggleEl = catEl.querySelector('.jsmenu-toggle');
                if (!open) {
                    catEl.classList.remove('jsmenu-open');
                    if (toggleEl) {
	                    toggleEl.title = EBContext.resource('ROZBALIT');
                        toggleEl.innerHTML = this.templates.iconClosed;
                    }
                } else {
                    catEl.classList.add('jsmenu-open');
                    if (toggleEl) {
	                    toggleEl.title = EBContext.resource('SBALIT');
                        toggleEl.innerHTML = this.templates.iconOpen;
                    }
                }
            },
            fnRenderCallback: function(scopeEl) {
                if (EBContext.ajaxNav && EBContext.ajaxNav instanceof EBContext.modules.AjaxNavigation) {
                    EBContext.ajaxNav.bindElements(EBContext.ajaxNav.findElements('link', scopeEl), 'link');
                }
            },
            fnToggleClick: function(event) {
                let catEl = event.currentTarget.closest('.jsmenu-item');
                self.toggleCategory(catEl.getAttribute('data-jsmenu-catid'), null, self.defaultRenderer, catEl);
                event.stopPropagation();
                event.preventDefault();
            }
        }
    };
    this.activeCatID = null;

    this.init = function(options) {
        self.options = EBContext.utils.extendObj(true, self.options, options);
        if(!self.options.data.seoidMap) self.options.data.seoidMap = {};
        if(!self.options.data.oidMap) self.options.data.oidMap = {};
        
        var setSorting = (cat,sorting)=>{
            if (!Array.isArray(cat))
                cat = Object.values(cat);
            let i, children;
            for (i = 0; i < cat.length; i++) {
                cat[i].Sorting = cat[i].Sorting || (sorting ? sorting + "-" : "") + ("00" + i).slice(-3);
                children = cat[i][self.options.data.propMap.Children];
                if (children && Object.keys(children).length > 0) {
                    setSorting(children, cat[i].Sorting);
                }
                if (!cat[i].hasOwnProperty('Children')){ // Children m� jen MENUCATEGORIES - MENUCMS m� jen Sub
                	cat[i].Sorting = 'cms_' + cat[i].Sorting;
                }
                self.options.data.oidMap[cat[i][self.options.data.propMap.OID]] = cat[i].Sorting;
                self.options.data.seoidMap[cat[i][self.options.data.propMap.SEOID]] = cat[i].Sorting;
            }
        };
        setSorting(self.options.data.categories, null);
    
        self.topLevel = Math.ceil(self.options.data.firstSorting.length / 4);
        self.defaultRenderer = new self.renderer();
    };

    this.renderer = function(options) {
        var renderer = this;
        this.options = EBContext.utils.mergeObj(false, self.options.render, options);
        if (this.options.menuWrapId) {
            this.menuWrapEl = document.getElementById(this.options.menuWrapId);
            if (this.options.closeOnOutsideClick) {
                document.addEventListener('click', event=>{
                    if (!this.menuWrapEl.contains(event.target))
                        self.closeAllCategories(renderer);
                });
                document.addEventListener('EBContext.ajaxNav.navigate', event=>self.closeAllCategories(renderer));
            }
        }
        return this;
    };

    this.saveCategory = function() {
        if (typeof (Storage) !== 'undefined') {
            sessionStorage.setItem('menuCategory', self.activeCatID);
            return true;
        }
        return false;
    };
    this.loadCategory = function() {
        if (typeof (Storage) !== 'undefined') {
            if (sessionStorage.menuCategory)
                return sessionStorage.menuCategory;
        }
        return false;
    };
    this.categoryEnabled = function(catObj) {
        if (typeof catObj === 'string')
            catObj = self.getCatObj(catObj);
        if (!catObj)
            return false;
        if (catObj.UseEBC === undefined)
            return true;
        // MenuCMS - ignorovat podm�nku a v�dy zobrazit

        let showCat = false;
        // M� kategorie EBC p��znak mezi EBC p��znaky p�ihl�en�ho customera?
        if (EBContext.data.session.Cust_UseEBC.split(';').find(ii=>{
            return (catObj.UseEBC.indexOf(ii) > -1);
        }
        )) {

            // M� p�ihl�en� Customer danou kategorii mezi povolen�mi kat. El. cen�ku?
            if (!EBContext.data.session.Cust_Categories || EBContext.data.session.Cust_Categories.toString().indexOf(catObj.OID) > -1) {
                showCat = true;
            }
        }
        return showCat;
    };
    this.getCatObj = function(catID, catScope) {
        if (!catScope) {
            catScope = {};
            catScope.Sorting = self.options.data.firstSorting;
            catScope[self.options.data.propMap.Children] = self.options.data.categories;
        }
        if ((!catID || catID === self.options.data.firstSorting || catID === 'root_category') && self.categoryEnabled(catScope))
            return catScope;
        var catObj;
        if (Array.isArray(catScope[self.options.data.propMap.Children])) {
            catObj = catScope[self.options.data.propMap.Children].find(item=>item.Sorting === catID);
            if (catObj && self.categoryEnabled(catObj))
                return catObj;
        }
        if (catScope[self.options.data.propMap.Children] && catScope[self.options.data.propMap.Children].hasOwnProperty(catID))
            return catScope[self.options.data.propMap.Children][catID];

        let prefix = (self.options.data.firstSorting ? self.options.data.firstSorting + '-' : '');
        let catPath = catID.substr(prefix.length).split('-');
        let nextSubCat;
        if (!catScope.Sorting || catScope.Sorting === self.options.data.firstSorting) {
            nextSubCat = prefix + catPath[0];
        } else {
            nextSubCat = prefix + catPath.slice(0, catScope.Sorting.substr(prefix.length).split('-').length + 1).join('-');
        }
        if (Array.isArray(catScope[self.options.data.propMap.Children])) {
            catObj = catScope[self.options.data.propMap.Children].find(item=>item.Sorting === nextSubCat);
        } else {
            catObj = catScope[self.options.data.propMap.Children][nextSubCat];
        }

        if (catObj && self.categoryEnabled(catObj))
            return self.getCatObj(catID, catObj);
        return false;
    };
    this.getCatID = function(seoid, oid) {
    	if(seoid){
	        if (seoid in self.options.data.seoidMap)
	            return self.options.data.seoidMap[seoid];
	        return '';
    	} else if(oid){
    		if (oid in self.options.data.oidMap)
	            return self.options.data.oidMap[oid];
	        return '';
    	}
    };
    this.getCatPath = function(catID, prop) {
        let prefix = (self.options.data.firstSorting ? self.options.data.firstSorting + '-' : '');
        let idPath = catID.substr(prefix.length).split('-');
        let catPath = [];
        let lastCat, nextSubCat;
        for (var i = 0; i < idPath.length; i++) {
            if (!lastCat || !lastCat.Sorting || lastCat.Sorting === self.options.data.firstSorting) {
                nextId = prefix + idPath[0];
                lastCat = self.options.data.categories[nextId];
            } else {
                nextId = prefix + idPath.slice(0, lastCat.Sorting.substr(prefix.length).split('-').length + 1).join('-');
                if(Array.isArray(lastCat[self.options.data.propMap.Children])){
                    lastCat = lastCat[self.options.data.propMap.Children].find(cat=>cat.Sorting===nextId);
                } else {
                    lastCat = lastCat[self.options.data.propMap.Children][nextId];
                }
                
            }
            if (!lastCat)
                lastCat = self.options.data.categories[nextId] || null;
            catPath.push((lastCat && prop ? lastCat[prop] : nextId));
        }
        return catPath;
    };

    this.processLinks = function(scope, renderer) {
        renderer = renderer || self.defaultRenderer;
        scope = scope || renderer.menuWrapEl || document;
        [...scope.querySelectorAll('a[href]')].forEach(el=>{
            if (el.href.indexOf('action:') === 0) {
                el.onclick = e=>{
                	e.preventDefault();
                    let actionArr = e.currentTarget.href.substr(7).split(';');
                    let actionObj = EBContext.utils.getObj('actions.' + actionArr[0], EBContext);
                    if (typeof actionObj === 'function')
                        actionObj.apply(null, actionArr.slice(1));
                    if(EBContext.sidebar) EBContext.sidebar.toggle(false);
                    return false;
                };
            }
        });
    };
    this.renderCategory = function(catID, renderer, scope) {
        renderer = renderer || self.defaultRenderer;
        scope = scope || renderer.menuWrapEl;
        if(!scope) return null;
		if(!catID) renderer.menuWrapEl.innerHTML = '';
        if (catID && this !== EBContext.jsMenu && catID.indexOf('cms_') === -1){
        	let custRenderer = EBContext.utils.mergeObj(false, renderer, {
                options:{templates:{itemHrefTemplate:EBContext.jsMenu.defaultRenderer.options.templates.itemHrefTemplate}}
            });
        	return EBContext.jsMenu.renderCategory(catID, custRenderer, scope);
        }
        if (catID && catID !== self.options.data.firstSorting && catID !== 'root_category' && !Object.values(self.options.data.categories).find(v=>(catID.indexOf(v.Sorting) === 0)))
            return null;
        if (!catID) {
            scope = renderer.menuWrapEl;
        } else if (catID.split('-').length < renderer.options.menuLevelLimit) {
            scope = scope.querySelector('[data-jsmenu-catid="' + catID + '"]') || (scope.getAttribute('data-jsmenu-catid') === catID ? scope : null);
            if (!scope){
				let s = self.renderCategory(catID.split('-').slice(0, -1).join('-'), renderer, scope);
				if(s) scope = s.querySelector('[data-jsmenu-catid="' + catID + '"]');
			}
			if (!scope) return null;
        } else {
            return null;
        }
        let catChildWrap;
        let catObj = self.getCatObj(catID);
        catObj = EBContext.utils.mergeObj(false, catObj, renderer.options.templateVariables);
        if (renderer.options.templates.childrenWrap) {
            catChildWrap = EBContext.utils.template(renderer.options.templates.childrenWrap, renderer.options.templates, catObj)[0];
        } else {
            catChildWrap = document.createElement('ul');
            catChildWrap.style.listStyleType = 'none';
            catChildWrap.style.marginBottom = '0';
            if(catObj.bgColor){
				catChildWrap.classList.add('bg-'+catObj.bgColor);
			} else {
				catChildWrap.classList.add('bg-inherit','text-inherit');
			}
            let items = self.options.data.fnSortCategories(catObj[self.options.data.propMap.Children] || []);
            for (let i = 0; i < items.length; i++) {
                let itemEl = self.createItem(items[i], renderer);
                if (itemEl)
                    catChildWrap.appendChild(itemEl);
            }
        }
        scope.appendChild(catChildWrap);
        self.processLinks(scope, renderer);
        renderer.options.fnRenderCallback(catChildWrap);
        return catChildWrap;
    };
    this.createItem = function(catObj, renderer, skipRender, propMap) {
        if (!self.categoryEnabled(catObj)) return null;
        renderer = renderer || self.defaultRenderer;
        if (!renderer.menuWrapEl) return null;
        if (catObj.Link && catObj.Link.indexOf('category:') === 0) {
            catObj.SEOID = catObj.Link.substr(9);
            if (catObj.SEOID === '') {
                catObj.Sorting = EBContext.jsMenu.options.data.firstSorting || 'root_category';
            } else {
                catObj.Sorting = EBContext.jsMenu.getCatID(catObj.SEOID);
            }
			if(!catObj.Sorting) return false;
            let title = catObj[self.options.data.propMap.Name] || '';
            let catSorting = catObj.Sorting;
            let bgColor = catObj.bgColor;
			let icon = catObj.Icon;
            let target = catObj.Target;
            catObj = EBContext.jsMenu.getCatObj(catObj.Sorting);
            catObj.Sorting = catSorting;
            let custRenderer = EBContext.utils.mergeObj(false, renderer, {
                options: {
                    templates: {
                        itemHrefTemplate: EBContext.jsMenu.defaultRenderer.options.templates.itemHrefTemplate
                    }
                }
            });
            let catOverride = {};
            let titleOverrideProp = EBContext.utils.getObj('options.data.propMap.title', EBContext.jsMenu);
            if (titleOverrideProp)
                catOverride[titleOverrideProp] = title;
                catOverride.bgColor = bgColor;
                catOverride.Target = target;
                catOverride.Icon = icon;
            return EBContext.jsMenu.createItem(EBContext.utils.mergeObj(false, catObj, catOverride), custRenderer, skipRender, this.options.data.propMap);
        }
        catObj.noLink = 'javascript:;';
        let opt = EBContext.utils.extendObj(false, {
            category: catObj,
            renderChildren: (Object.values(catObj[self.options.data.propMap.Children]).filter(el=>self.categoryEnabled(el)).length > 0 && catObj.Sorting.split('-').length < renderer.options.menuLevelLimit)
        }, renderer.options.templateVariables);
        for (const [key,value] of Object.entries(self.options.data.propMap))
            opt[key] = catObj[value];
        if(propMap)
        	for (const [key,value] of Object.entries(propMap))
            	opt[key] = catObj[value];
        opt.title = opt.title || catObj.title || catObj.Name || '';
        opt.tooltip = catObj.Tooltip || '';
        if(skipRender) return opt;
        let itemEl = EBContext.utils.template('<!--#menuItem-->', renderer.options.templates, opt)[0];
        itemEl.setAttribute('data-jsmenu-catid', catObj.Sorting);
        let itemLink = itemEl.querySelector('.jsmenu-link');
        if (itemLink) {
            itemLink.href = EBContext.utils.template('<!--#itemHrefTemplate-->', renderer.options.templates, catObj, true);
            if (catObj.onclick)
                itemLink.addEventListener('click', catObj.onclick);
        }
        let toggleButton = itemEl.querySelector('.jsmenu-toggle');
        if (toggleButton) {
            toggleButton.addEventListener('click', renderer.options.fnToggleClick);
            if (itemLink && itemLink.href === catObj.noLink)
                itemLink.addEventListener('click', ()=>toggleButton.click());
        }
        return itemEl;
    };
    this.openCategory = function(catID, renderer, scope) {
        renderer = renderer || self.defaultRenderer;
        scope = scope || renderer.menuWrapEl;
        if (!scope) return null;        
        if (catID && !Object.values(self.options.data.categories).find(v=>(catID.indexOf(v.Sorting) === 0)))
            return null;
        if (!self.categoryEnabled(catID)) {
            let parentCatID = catID.split('-').slice(0, -1).join('-');
            if (parentCatID)
                return self.openCategory(parentCatID, renderer, scope);
            return false;
        }
        if (catID && catID.split('-').length < renderer.options.menuLevelLimit) {
            if (renderer.options.closeInactive)
                self.closeAllCategories(renderer);
            if ((catID || !renderer.menuWrapEl.querySelector('ul')) && !scope.querySelector('[data-jsmenu-catid="' + catID + '"] ul')) {
                self.renderCategory(catID, renderer, scope);
            }
            if (catID)
                self.toggleCategory(catID, true, renderer, scope);
            self.activeCatID = catID;
            self.saveCategory();
            return true;
        }
        return false;
    };
    this.toggleCategory = function(catID, open, renderer, scope) {
        renderer = renderer || self.defaultRenderer;
    	scope = scope || renderer.menuWrapEl;
        if(!scope) return null;
        
        let catEl = scope.querySelector('[data-jsmenu-catid="' + catID + '"]') || (scope.getAttribute('data-jsmenu-catid') === catID ? scope : null);
        if (catEl) {
            if (!open && EBContext.utils.element.isVisible(catEl.querySelector('ul'))) {
                renderer.options.fnToggleCategory(catEl, false);
            } else {
                let catPath = catID.split('-');
                let catLevel = catPath.length;
                if (catID && catID === self.options.data.firstSorting)
                    catLevel++;
                for (let iLevel = 1 + self.topLevel; iLevel <= catLevel; iLevel++) {
                    let iCatID = catPath.slice(0, iLevel).join('-');
                    let iCatEl = scope.querySelector('[data-jsmenu-catid="' + iCatID + '"]') || (scope.getAttribute('data-jsmenu-catid') === iCatID ? scope : null);
                    if (iCatEl) {
                        if (!iCatEl.querySelector('ul')) {
                            self.renderCategory(iCatID, renderer, scope);
                        }
                        if (renderer.options.closeInactive)
                            self.closeOtherCategories(catEl, renderer);
                        renderer.options.fnToggleCategory(iCatEl, true);
                    }
                }
            }
        }
    };
    this.closeOtherCategories = function(categoryEl, renderer) {
        renderer = renderer || self.defaultRenderer;
        if (!renderer.menuWrapEl)
            return null;
        let items = renderer.menuWrapEl.querySelectorAll('.jsmenu-item.jsmenu-open');
        for (let i = 0; i < items.length; i++) {
            if (!items[i].contains(categoryEl))
                renderer.options.fnToggleCategory(items[i], false);
        }
    };
    this.closeAllCategories = function(renderer) {
        return self.closeOtherCategories(null, renderer);
    };
    let instances = EBContext.utils.searchObj(EBContext, 'instances.jsmenu', true);
    this.id = Object.keys(instances).length;
    EBContext.utils.setObj(instances, 'jsmenu_' + this.id, this);
    return this;
};
EBContext.jsMenu = new EBContext.modules.JSMenu();
EBContext.jsMenu.init();
// Zinicializuje JSMenu s default options, jen aby se vytvo�il defaultRenderer
// document.addEventListener('EBContext.session.setLanguage', ()=>EBContext.jsMenu.init({data: {languageIndex: EBContext.data.languageIndex}}));

EBContext.modules.SidebarMenu = function(options) {
    const self = this;
    this.options = {
        togglerSelector: '#menuBtn',
        menuTitle: EBContext.resource('MENU'),
        bodyClass: ' container-fluid gx-0',
        global: false,
        transition: {
            style: 'slide',
            // slide, appear, ...
            timeout: 500,
            properties: {}
        },
        boxOptions: {
            order: null,
            isHidden: false,
            inSidebar: false,
            triggerEl: null
        }
    };
    this.boxes = [];
    this.togglerEl;
    this.sidebarEl;
    this.bodyEl;
    this.closeEl;
    this.overlayEl;
	this.toggle = (open, skipTransition)=>{
		if (typeof open === 'undefined') open = !this.sidebarEl.classList.contains('ebc-sidebar-open');
        // console.trace('sidebarMenu.toggle', open, skipTransition, this);
        
        if (open) {
            self.refresh();
            this.sidebarEl.style.display = '';
            if(skipTransition){
            	this.sidebarEl.classList.add('ebc-sidebar-open');
            } else {
	            setTimeout(()=>{this.sidebarEl.classList.add('ebc-sidebar-open'); console.timeEnd('sidebar_open')}, self.options.transition.timeout);
            }
            document.body.classList.add('modal-open');
            document.activeElement.blur();
        } else {
            this.sidebarEl.classList.remove('ebc-sidebar-open');
            if(skipTransition){
            	this.sidebarEl.style.display = 'none';
            } else {
	            setTimeout(()=>{this.sidebarEl.style.display = 'none'}, self.options.transition.timeout);
            }
            document.body.classList.remove('modal-open');
            document.body.style.right = 0;

            let focusedEl = this.sidebarEl.querySelector(':focus');
            if (focusedEl) focusedEl.blur();
        }
    };
    this.init = (options)=>{
    	// console.trace('sidebarMenu.init', options, this);
        EBContext.utils.extendObj(false, this.options, options || {});
        this.id = this.options.id || 'sidebar';
        let suffix = 0, id = this.id;
		while(document.getElementById(this.id)){
			suffix++;
			this.id = id + '_' + suffix;
		}
	    this.togglerEl = document.querySelector(this.options.togglerSelector);
        this.sidebarEl = this.options.sidebarEl || EBContext.utils.template('<div class="ebc-sidebar" id="<!--~sidebarid-->"><!--#overlay--><!--#panel--></div>', {
            overlay: '<div class="ebc-sidebar-overlay"></div>',
            panel: '<div class="ebc-sidebar-panel <!--$transitionClass-->"><!--#header--><!--#body--></div>',
            header: '<header class="ebc-sidebar-header bg-light border-bottom"><div class="ebc-sidebar-title"><!--$title--></div><!--#close--></header/>',
            close: '<button class="ebc-sidebar-close btn btn-danger m-2"><i class="fas fa-times"></i></button>',
            body: '<div class="ebc-sidebar-body<!--$bodyClass-->"></div>',
            footer: '<div class="ebc-sidebar-footer"></div>'
        }, {
        	sidebarid: self.id,
            title: self.options.menuTitle,
            bodyClass: self.options.bodyClass,
            transitionClass: 'ebc-sidebar-' + self.options.transition.style,
        })[0];
        if (!document.body.contains(this.sidebarEl)) document.body.appendChild(this.sidebarEl);
        this.sidebarEl.style.display = 'none';

        this.sidebarEl.style.setProperty('--transition-timeout', self.options.transition.timeout / 1000 + 's');
        for (let tp in self.options.transition.properties) {
            this.sidebarEl.style.setProperty('--transition-' + tp, self.options.transition.properties[tp]);
        }

        this.bodyEl = this.sidebarEl.querySelectorAll('.ebc-sidebar-body')[0] || null;
        this.overlayEl = this.sidebarEl.querySelectorAll('.ebc-sidebar-overlay')[0] || null;
        this.closeEl = this.sidebarEl.querySelectorAll('.ebc-sidebar-close')[0] || null;
        this.closeEl.addEventListener('click', ()=>self.toggle(false));
        this.togglerEl && this.togglerEl.addEventListener('click', ()=>self.toggle());
        if (self.overlayEl) self.overlayEl.addEventListener('click', ()=>self.toggle(false));
        self.sidebarEl.addEventListener('keydown', e=>(e.code === 'Escape' ? self.toggle(false) : null));

		self.refresh();
        if (!self.initialized) {
            self.bodyWidth = document.body.clientWidth;
	        window.addEventListener('load', self.refresh);
            window.addEventListener('resize', ()=>{
            	if(self.bodyWidth !== document.body.clientWidth){
					self.bodyWidth = document.body.clientWidth;
					self.refresh();
				}
            });
            document.addEventListener('EBContext.ajaxNav.bodyReload', ()=>{self.destroy()}, {once:true});
            if(self.options.global) document.addEventListener('EBContext.ajaxNav.bodyReloaded', ()=>{self.init()});
        }
        if(!this.options.global){
            document.addEventListener('EBContext.ajaxNav.navigate', ()=>self.destroy(), {once:true});
        	// document.addEventListener - TODO - doplnit spr�vu event listener� (asi do EBContext.js), aby na str�nce nez�st�val ��dn�, kter� manipuluje s DOM elementem, kter� tam u� po navigaci nen�!
        }
    };
    this.register = (selector,options)=>{
        options = options || {};
        options = EBContext.utils.mergeObj(false, self.options.boxOptions, options);
        options.order = (options.order === null ? 0 : options.order);

        let elArr = document.querySelectorAll(selector);
        let i;
        for (i = 0; i < elArr.length; i++) {
            if (self.boxes.find(a=>a.boxEl === elArr[i]) === undefined) {
                if (self.boxes.find(a=>a.options.order === options.order)) {
                    let prevElArr = self.boxes.filter(a=>(a.options.order >= options.order && a.options.order < options.order + 1));
                    options.order = prevElArr[prevElArr.length - 1].options.order + 0.001;
                }
                if (true || elArr[i].closest('.noelicons'))
                    elArr[i].classList.add('noelicons');
                self.boxes.push({
                    boxEl: elArr[i],
                    parentEl: elArr[i].parentElement,
                    options: options
                });
            }
        }
        self.boxes = self.boxes.sort((a,b)=>a.options.order - b.options.order);
    };
    this.refresh = (state)=>{
        let i, boxEl;
        for (i = 0; i < self.boxes.length; i++) {
            let triggerEl = self.boxes[i].options.triggerEl || self.boxes[i].parentEl;
            if(state !== undefined){
            	self.boxes[i].options.isHidden = !state;
            } else {
	            self.boxes[i].options.isHidden = (!EBContext.utils.element.isVisible(triggerEl));
            }
            self.boxes[i].options.inSidebar = self.bodyEl.contains(self.boxes[i].boxEl);
            if (!document.body.contains(self.boxes[i].parentEl)) { // Pokud u� p�vodn� parent nen� v BODY, tak se box odstran�
                if (self.boxes[i].options.inSidebar) self.bodyEl.removeChild(self.boxes[i].boxEl);
                self.boxes.splice(i, 1);
                i--;
            } else if (!self.boxes[i].options.isHidden && self.boxes[i].options.inSidebar) { // pokud nen� box skryt� a st�le je v sidebaru, tak se p�esune ze sidebaru do p�vodn�ho parent elementu
                boxEl = self.boxes[i].boxEl.parentElement.removeChild(self.boxes[i].boxEl);
                self.boxes[i].parentEl.appendChild(boxEl);
            } else if (self.boxes[i].options.isHidden && !self.boxes[i].options.inSidebar) { // pokud je box skryt� a je�t� nen� v sidebaru, tak se p�esune ze p�vodn�ho parent elementu do sidebaru
            	boxEl = self.boxes[i].boxEl;
            	if(self.boxes[i].parentEl.contains(self.boxes[i].boxEl)) boxEl = self.boxes[i].parentEl.removeChild(self.boxes[i].boxEl);
                let prevElArr = self.boxes.filter(a=>(a.options.order < self.boxes[i].options.order && a.options.inSidebar));
                (prevElArr.length ? prevElArr[prevElArr.length - 1].boxEl.after(boxEl) : self.bodyEl.appendChild(boxEl));
            }
        }
        if (!self.bodyEl.children.length)
            self.toggle(false);
    };
    this.destroy = ()=>{
		// console.trace('sidebarMenu.destroy', this);
		self.toggle(false, true); // Zav��t sidebar
        self.refresh(true); // P�esunout v�echny boxy ze sidebaru do p�vodn�ch parent element� aby se mohly navigac� p�epsat a neduplikovaly se
    	if(!self.boxes.find(bel=>self.sidebarEl.contains(bel.boxEl))){ // Pokud v sidebaru nejsou ��dn� boxy, tak jej odstranit z BODY
    		if(document.body.contains(self.sidebarEl)) document.body.removeChild(self.sidebarEl);
		} else {
			self.refresh(false);
		}
		if('function' === typeof self.options.destroyCallback) self.options.destroyCallback();
    };
    this.init(options);
    this.initialized = true;
    return this;
}
EBContext.sidebar = new EBContext.modules.SidebarMenu({global:true,id: 'primary_sidebar'});


EBContext.modules.Breadcrumbs = function(options) {
    var self = this;
    this.options = EBContext.utils.extendObj(false, {
        renderHome: true,
        lastIsActive: true,
        wrapSelector: '#breadcrumbs',
        templates: {
            home: '<li class="breadcrumb-item home <!--~truncateText?"text-truncate":"text-wrap"-->"><a class="text-reset" href="'+(EBContext.data.languageUrl || '/')+'" title="' + EBContext.resource("DOMU") + '">' + EBContext.resource("DOMU") + '</a></li>',
            active: '<li class="breadcrumb-item active <!--~truncateText?"text-truncate":"text-wrap"-->" title="<!--$name-->"><!--$name--></li>',
            default: '<li class="breadcrumb-item <!--~truncateText?"text-truncate":"text-wrap"-->" title="<!--$name-->"><a class="text-reset" href="<!--$link-->" title="<!--$name-->"><!--$name--></a></li>',
            disabled: '<li class="breadcrumb-item disabled <!--~truncateText?"text-truncate":"text-wrap"-->" title="<!--$name-->"><!--$name--></li>'
        },
        jsMenu: EBContext.jsMenu,
        categoryLink: EBContext.data.hrefMap.result_categoryseoid || EBContext.data.languageUrl + '/categories/<!--$SEOID-->',
        showDisabled: 0,
        truncateText: true
    }, options);
    this.render = function(subTitle, breadcrumbs, options) {
        options = EBContext.utils.mergeObj(false, self.options, options);
        let i, j, props, breadcrumbsStr = '', breadcrumbStr = '';

        breadcrumbs = breadcrumbs || [];

        // Posledn� drobek je v�dy aktu�ln� nadpis (pokud je p�edan�) - pou��v� se na Detailu
        if (subTitle && (!breadcrumbs.length || breadcrumbs[breadcrumbs.length - 1].name !== subTitle)) {
            breadcrumbs.push({
                type: 'active',
                name: subTitle
            });
        }// Pokud nen� p�edan� nadpis, nastav� se posledn� p�edan� drobek jako aktivn� - pou��v� se na Resultu
        else if (breadcrumbs.length && options.lastIsActive) {
            breadcrumbs[breadcrumbs.length - 1].type = 'active';
        }

        // standardizovat drobky - m�/nem� home; posledn� je active
        if (options.renderHome && (!breadcrumbs.length || breadcrumbs[0].type !== 'home')) {
            breadcrumbs.unshift({
                type: 'home'
            });
        } else if (!options.renderHome && breadcrumbs.length && breadcrumbs[0].type === 'home') {
            breadcrumbs.shift();
        }

        // Vyrenderovat drobky dle templates
        for (i = 0; i < breadcrumbs.length; i++) {
            breadcrumbStr = options.templates[breadcrumbs[i].type] || options.templates.default;
            breadcrumbsStr += EBContext.utils.template(breadcrumbStr, {}, EBContext.utils.extendObj(false, options, breadcrumbs[i]), true);
        }

        // Nasypat drobky do DOM
        if (breadcrumbsStr && options.wrapSelector) {
            let breadcrumbsEl = document.querySelector(options.wrapSelector);
            breadcrumbsEl.innerHTML = breadcrumbsStr;
            // AjaxNavigation je require shim pro JSMenu, tak�e tady mus� b�t k dispozici
            EBContext.ajaxNav.bindElements(EBContext.ajaxNav.findElements('link', breadcrumbsEl), 'link');
        }
        return breadcrumbsStr;
    };
    this.renderCategory = function(subTitle, catID, options) {
        options = EBContext.utils.mergeObj(false, self.options, options);
        let breadcrumbs = [];
        if (catID && catID.length > options.jsMenu.options.data.firstSorting.length) {
            let breacrumbsArr = catID.split('-');
            catID = options.jsMenu.options.data.firstSorting;
            let catObj = false;
            options.categoryLink = options.categoryLink.replace('###SEOID###', '<!--$SEOID-->');
            for (var j = options.jsMenu.topLevel; j < breacrumbsArr.length; j++) {
                if (catID !== '')
                    catID += '-';
                catID += breacrumbsArr[j];
                catObj = options.jsMenu.getCatObj(catID, catObj);
                if (catObj) {
                    let catEnabled = options.jsMenu.categoryEnabled(catObj);
                    if (catEnabled || options.showDisabled === 2) {
                        let breadcrumb = {
                            name: catObj.Name || '',
                            type: (catEnabled ? 'default' : 'disabled'),
                            link: EBContext.utils.template(options.categoryLink, {}, EBContext.utils.extendObj(false, options, catObj), true)
                        };
                        breadcrumbs.push(breadcrumb);
                    }
                }
            }
        }
        return self.render(subTitle, breadcrumbs, options);
    };
    return this;
};
EBContext.breadcrumbs = new EBContext.modules.Breadcrumbs();

EBContext.modules.ElementSlider = function(options) {
    this.options = EBContext.utils.extendObj(false, {
        scrollEl: null,
        prevHTML: '<button class="btn text-reset btnPrev" type="button"><i class="fas fa-fw fa-chevron-left"></i></button>',
        nextHTML: '<button class="btn text-reset btnNext" type="button"><i class="fas fa-fw fa-chevron-right"></i></button>'
    }, options);
    var self = this;

    this.init = options=>{
        this.options = EBContext.utils.extendObj(false, this.options, options);
        if (typeof this.options.scrollEl === 'string')
            this.options.scrollEl = document.querySelector(this.options.scrollEl);

        this.scrollEl = this.options.scrollEl;
        this.scrollEl.classList.add('elementSliderEl');
        this.scrollWrapEl = this.scrollEl.parentElement;
        this.scrollWrapEl.classList.add('elementSliderWrap');
		this.scrollWidth = this.scrollEl.scrollWidth;

        if (!document.querySelector('style#elementSliderStyle')) {
            let styleEl = document.createElement('style');
            styleEl.id = 'elementSliderStyle';
            styleEl.innerHTML = '.elementSliderWrap{width:100%;display:flex;flex-direction:row !important} .elementSliderEl{display:flex;flex-grow:1;overflow-x:hidden;overflow-x:clip;width:calc(100% - 2.5em - 3rem)}';
            document.body.append(styleEl);
        }

        this.isDown = false;

        const end = ()=>{
            this.isDown = false;
            this.scrollEl.classList.remove('activeSlider');
        }
        const start = (e)=>{
            if (!this.scrollEl.style.left)
                this.scrollEl.style.left = 0;
            this.isDown = true;
            this.scrollEl.classList.add('activeSlider');
            this.startX = (e.pageX || e.touches[0].pageX) - parseFloat(this.scrollEl.firstChild.style.marginLeft.replace('px', ''));
        }
        const move = (e)=>{
            if (!this.isDown)
                return;
            e.preventDefault();
            const x = (e.pageX || e.touches[0].pageX)-this.startX;
            if (x<=0 && x>=self.scrollEl.clientWidth-self.scrollWidth) {
                this.scrollEl.firstChild.style.marginLeft = x + 'px';
            }
        }
        this.scrollEl.addEventListener('mousedown', start);
        this.scrollEl.addEventListener('touchstart', start);
        this.scrollEl.addEventListener('mousemove', move);
        this.scrollEl.addEventListener('touchmove', move);
        this.scrollEl.addEventListener('mouseleave', end);
        this.scrollEl.addEventListener('mouseup', end);
        this.scrollEl.addEventListener('touchend', end);

        this.prevEl = EBContext.utils.createDOM(self.options.prevHTML)[0];
        this.nextEl = EBContext.utils.createDOM(self.options.nextHTML)[0];
        this.prevEl.addEventListener('click', e=>{
            let left = parseInt(self.scrollEl.firstChild.style.marginLeft.replace('px', '')) || 0;
            let step = -self.scrollEl.clientWidth / 2;
            if (step < left) step = left;
            self.scrollEl.firstChild.style.marginLeft = (left - step) + 'px';
        });
        this.nextEl.addEventListener('click', e=>{
            let left = parseInt(self.scrollEl.firstChild.style.marginLeft.replace('px', '')) || 0;
            let right = parseInt(self.scrollEl.lastChild.style.marginRight.toString().replace('px', '')) || self.scrollEl.clientWidth - self.scrollEl.scrollWidth;
            let step = -self.scrollEl.clientWidth / 2;
            if (step < right) step = right;
            self.scrollEl.firstChild.style.marginLeft = (left + step) + 'px';
        });
        this.scrollWrapEl.prepend(this.prevEl);
        this.scrollWrapEl.append(this.nextEl);

        let ro = new ResizeObserver(()=>self.refresh());
        ro.observe(this.scrollWrapEl);
        this.refresh();
    };
    this.refresh = ()=>{
        if (this.scrollEl.scrollWidth > this.scrollWrapEl.clientWidth) {
            this.prevEl.classList.remove('d-none');
            this.nextEl.classList.remove('d-none');
        } else {
            this.prevEl.classList.add('d-none');
            this.nextEl.classList.add('d-none');
        }
        this.scrollEl.firstChild.style.marginLeft = 0 + 'px';
        this.scrollEl.lastChild.style.marginRight = 0 + 'px';
    };
    this.init();
    return this;
};